import { DetailCard } from "@hatch-digital-nl/abs-storybook/legacy";
import { JSX, useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../../app/hooks";
import { CertificateInterface } from "../../../../common/interfaces/CertificateInterface";
import { CertificateStatusEnum } from "../../../../common/enums/CertificateStatusEnum";
import Skeleton from "react-loading-skeleton";
import { getActionData } from "../../utils/getActionData";
import { getRenewButtonImage } from "../../utils/getRenewButtonImage";
import { getRenewButtonText } from "../../utils/getRenewButtonText";
import { getEmployeeCertificateCardActionData } from "../../utils/getEmployeeCertificateCardActionData";
import { getEmployeeCertificateCardAlert } from "../../utils/getEmployeeCertificateCardAlert";
import { getEmployeeCertificateCardMetadata } from "../../utils/getEmployeeCertificateCardMetadata";

interface Props {
    certificateData?: CertificateInterface[];
    certificateDataIsLoading: boolean;
    certificateDataIsFetching: boolean;
    refetchCertificateData: () => void;
    isPatchEditCertificateSuccess: boolean;
    isPostCreateCertificateSuccess: boolean;
    activeTab: string;
}

export const EmployeeCertificatesContent = (
    props: Props,
): JSX.Element | null => {
    const {
        certificateData,
        certificateDataIsLoading,
        certificateDataIsFetching,
        refetchCertificateData,
        isPatchEditCertificateSuccess,
        isPostCreateCertificateSuccess,
        activeTab,
    } = props;
    const dispatch = useAppDispatch();
    const { isOpenFormLoading } = useAppSelector(
        (state) => state.editCertificateModal,
    );

    useEffect(() => {
        if (isPatchEditCertificateSuccess || isPostCreateCertificateSuccess) {
            refetchCertificateData();
        }
    }, [
        isPatchEditCertificateSuccess,
        isPostCreateCertificateSuccess,
        refetchCertificateData,
    ]);

    if (certificateDataIsLoading || certificateDataIsFetching) {
        return (
            <Skeleton height={"12.3rem"} count={5} borderRadius={"1.5rem"} />
        );
    }

    if (!certificateData) {
        return null;
    }

    return (
        <>
            {certificateData.map((certificate: CertificateInterface, index) => {
                const actionData =
                    activeTab === CertificateStatusEnum.ACTIVE ||
                    activeTab === CertificateStatusEnum.PENDING
                        ? getActionData({
                              dispatch,
                              item: certificate,
                              isOpenFormLoading,
                          })
                        : [];

                const showRenewButton =
                    activeTab === CertificateStatusEnum.EXPIRED ||
                    activeTab === CertificateStatusEnum.REJECTED;

                return (
                    <DetailCard
                        key={index}
                        title={certificate.qualification.name}
                        metadata={getEmployeeCertificateCardMetadata({
                            certificate,
                        })}
                        actions={getEmployeeCertificateCardActionData({
                            certificate,
                            dispatch,
                            isOpenFormLoading,
                            actionData,
                            showRenewButton,
                            renewButtonText: getRenewButtonText(activeTab),
                            renewButtonImage: getRenewButtonImage(activeTab),
                        })}
                        alert={getEmployeeCertificateCardAlert({
                            certificate,
                            activeTab,
                        })}
                    />
                );
            })}
        </>
    );
};
